export const RQ_GET_CML_REPORT_API = {
  url: 'reports/customer/cml/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
